<template>
  <ion-page class="sign">
    <common-background
      :has-mode-switch="hasModeSwitch"
      :title="pageTitle"
      router-type="modal"
      @router-back="onConfirmClose"
    >
      <template #default>
        <div class="sign_page">
          <div class="word-list">
            <ion-item-sliding
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row cursor-pointer"
              :class="{ 'item-checked': item.checked }"
              @ionDrag="onDrag"
            >
              <div v-if="wordSequence[currentWordIndex] === index" class="left-line"></div>

              <ion-item
                class="ion-item signItem flex-row justify-between align-center"
                :style="item.wordPhoneticType !== 'word' ? 'padding-bottom:3vw' : ''"
                @click="onShowParaphrase(index, item, true)"
              >
                <div v-if="wordTypeSwitch" class="four-line-three-grid">
                  <div class="line1"></div>
                  <div class="line2"></div>
                  <div class="line3"></div>
                  <div class="line4"></div>
                  <span v-if="wordSequence[currentWord] == item.word" class="tip"></span>
                  <div class="enword-list">
                    <template v-if="item.showParaphrase != 3">
                      <div v-for="(i, n) in item.wordDivisionList" :key="i">
                        <span :style="{ color: wordColor[n % 5] }" style="letter-spacing: 0">{{
                          i
                        }}</span>
                        <span
                          v-if="n !== item.wordDivisionList.length - 1"
                          style="color: #c1b7ad; margin: -0.1rem"
                          >{{ item.wordDivisionType === "word" ? "·" : "&nbsp;" }}</span
                        >
                      </div>
                    </template>
                  </div>
                  <div class="cnword-content">
                    <div
                      v-if="item.wordPhoneticList && item.wordPhoneticType === 'word'"
                      class="cnword-content-phonetic"
                    >
                      <span style="color: #676767; margin-right: 0.3rem">[</span>
                      <span v-for="(i, n) in item.wordPhoneticList" :key="i">
                        <span
                          :style="{
                            color:
                              item.wordPhoneticList.length === 1 ? '#676767' : wordColor[n % 5],
                          }"
                          style="letter-spacing: -0.05rem"
                          >{{ i }}</span
                        >
                        <span
                          v-if="n !== item.wordPhoneticList.length - 1"
                          style="color: #676767"
                          >{{ item.wordPhoneticType === "word" ? "·" : "&nbsp;" }}</span
                        >
                      </span>
                      <span style="color: #676767; margin-left: 0.3rem">]</span>
                    </div>
                    <span v-show="item.showParaphrase == 2" class="cnword-list">{{
                      item.paraphrase
                    }}</span>
                  </div>
                </div>
                <template v-else>
                  <div class="w100 flex-row justify-between align-center flex-wrap">
                    <div class="word-content flex-row flex-wrap ion-align-items-baseline">
                      <span
                        class="word-style switch-font-size flex-row align-center mr-3"
                        :class="{
                          'visibility-hidden': isManual
                            ? item.showParaphrase == 3
                            : item.showParaphrase == 4,
                        }"
                      >
                        {{ item.word }}
                      </span>
                      <span
                        class="cnword word-style gray-color"
                        :class="{
                          'display-none': isManual
                            ? item.showParaphrase != 2
                            : item.showParaphrase != 3,
                        }"
                      >
                        {{ item.paraphrase }}
                      </span>
                    </div>
                    <div
                      v-if="(!item.autoIndex && item.checked) || autoShowClickButton(index, item)"
                      class="word-style auto-button"
                    >
                      <img
                        v-if="!item.autoIndex && item.checked"
                        :src="getBrandImageUrl('speed/two_one.png')"
                        style="width: 8vw"
                        alt=""
                        @click.stop="
                          playUniversalFormulaAudio(item.word, item.paraphrase, 50 * speedRate)
                        "
                      />
                      <div
                        v-if="autoShowClickButton(index, item)"
                        :class="[
                          'auto-index',
                          autoAudio?.loading && currentPlayingIndex === index
                            ? 'auto-index__disabled'
                            : `auto-index-${item.autoIndex}`,
                        ]"
                        :style="{
                          '--progress': isNaN(progress) ? '0%' : `${progress}%`,
                          '--last': isNaN(progress) ? '100%' : `${100 - progress}%`,
                        }"
                        :data-progress="item.autoIndex"
                        @click.stop="debouncePlayAudio(index, item)"
                      ></div>
                    </div>
                  </div>
                </template>
              </ion-item>
              <ion-item-options>
                <ion-item-option class="sign-option" @click="openErrorSubmitDialog(item, $event)">
                  <img :src="getBrandImageUrl('speed/sign_error.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="markDifficult(item.vocabularyId, $event)"
                >
                  <img :src="getBrandImageUrl('speed/sign_collect.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="onParaphrase(item.word, $event)"
                >
                  <img :src="getBrandImageUrl('speed/sign_detail.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="routerToAiVocabulary(item.word)"
                >
                  <img
                    style="height: 5rem"
                    :src="getBrandImageUrl('speed/sign_dictionary.png')"
                    alt=""
                  />
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </div>
        </div>
      </template>
      <template #rightTitle="slotProps">
        <img
          v-if="isManual && wordTypeSwitch"
          class="mode-switch1 mr-3"
          src="@/assets/speed/four_active.png"
          alt=""
          @click="changeWordType"
        />
        <img
          v-if="isManual && !wordTypeSwitch"
          class="mode-switch1 mr-3"
          src="@/assets/speed/four.png"
          alt=""
          @click="changeWordType"
        />
        <img
          :title="!isManual ? '人工' : 'ai带读'"
          class="mode-switch mr-2"
          :class="{ 'button-disabled': !hasModeSwitch }"
          :style="slotProps.style"
          :src="exerciseModalTxt"
          alt=""
          @click="changeExerciseModal"
        />
        <speed-switch v-if="!isManual" class="mr-2" />
        <switch-font-size v-if="!wordTypeSwitch" />
      </template>
    </common-background>
    <div class="sign_bottom">
      <div class="sign_bottom-content flex-row justify-between align-center">
        <span
          ><span class="common-color">{{ currentStep }}</span
          >/{{ totalPage }}</span
        >
        <div>
          <!--<ion-button shape="round" class="light_green_bg" @click="changeExerciseModal">
            <img :src="exerciseModalTxt" alt="" />
            {{ exerciseModalTxt }}
          </ion-button>-->
          <img
            v-if="clickedAll"
            title="快闪魔方"
            class="button-icon"
            src="@/assets/teacher_index/version5/cut_box.svg"
            alt=""
            @click="openCutBox"
          />
          <!--<ion-button v-if="clickedAll" class="light_green_bg" shape="round" @click="openCutBox">
            <img class="button" :src="getBrandImageUrl('speed/scissors_button.png')" alt="" />
          </ion-button>-->
          <img
            title="打乱"
            class="button-icon"
            src="@/assets/teacher_index/version5/random_play.svg"
            alt=""
            @click="throttledRandom"
          />
          <!--<ion-button class="light_green_bg ml-2" shape="round" @click="throttledRandom">
            <img class="button" :src="getBrandImageUrl('speed/random_button.png')" alt="" />
          </ion-button>-->
          <img
            v-if="isManual"
            title="标准读音"
            class="button-icon"
            src="@/assets/teacher_index/version5/standard_sound.svg"
            alt=""
            @click="onSpeak"
          />
          <!--<ion-button
            class="light_green_bg ml-2"
            shape="round"
            :disabled="!isManual"
            @click="onSpeak"
          >
            <img class="button" :src="getBrandImageUrl('speed/play_button.png')" alt="" />
          </ion-button>-->
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonPage,
  modalController,
} from "@ionic/vue"

import myAjax from "axios"
import {
  cut,
  documentTextSharp,
  flagSharp,
  playSkipBack,
  playSkipForward,
  shuffle,
  volumeHigh,
} from "ionicons/icons"
import Paraphrase from "./Paraphrase"
import CutBox from "@/views/speed/CutBox"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import AIGenerate from "@/views/AIGenerate/AIGenerate.vue"
import switchModeDialog from "@/views/speed/switchModeDialog.vue"
import PageDialog from "@/components/PageDialog.vue"
import { useStorage, useThrottleFn } from "@vueuse/core"
import SpeedSwitch from "@/components/speedSwitch.vue"
import getOssPlayInstance from "@/js/ossPlay"
import ErrorSubmitDialog from "@/components/ErrorSubmitDialog.vue"
import { getBrandImageUrl } from "@/js/brandImages"
import aiClassing from "@/assets/teacher_index/version5/ai_classing.svg"
import handleClick from "@/assets/teacher_index/version5/handle_click.svg"
import { debounce } from "lodash"
import disabledAi from "@/assets/teacher_index/version5/disabled_ai.svg"
import disabledArtificial from "@/assets/teacher_index/version5/disabled_artificial.svg"
import SwitchFontSize from "@/views/other/SwitchFontSize.vue"

const speedRate = useStorage("xf-speed", 1, localStorage)
export default {
  name: "SpeedSign",
  components: {
    SwitchFontSize,
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonItem,
    IonItemSliding,
    IonItemOption,
    IonItemOptions,
  },
  props: ["studentId", "step"],
  setup() {
    return {
      playSkipBack,
      playSkipForward,
      cut,
      shuffle,
      volumeHigh,
      flagSharp,
      documentTextSharp,
      speedRate,
    }
  },

  data() {
    return {
      pageTitle: "单词识记",
      isDisabled: false,
      dataList: [],
      totalPage: undefined, //总页数

      //___________________________________

      wordSequence: [], //练习流程
      isDownward: true, //自动发音方向
      speakIndex: 0, //当前发音数组下标
      currentStep: 1, // 当前组的下标
      currentWordIndex: 1, // 当前所学单词在整个练习流程中的数组下标
      autoButtonIndex: 0, //显示自动点击按钮,决定当前显示哪一个按钮
      currentItem: {}, // 当前框选的行数据
      isManual: true,
      exerciseModalTxt: aiClassing,
      throttledRandom: useThrottleFn(this.doRandom, 1000),
      autoAudio: getOssPlayInstance(), // 初始化为单例实例，确保能检测到所有音频播放状态（包括 playUniversalFormulaAudio）
      progress: 0,
      currentSpeakItem: {},
      isAutoSpeechPlaying: false, // 标识当前是否正在播放自动领读音频
      hasModeSwitch: true,
      slidingItemClicked: false,
      timer: null,
      currentPlayingIndex: -1,
      disabledAi: disabledAi,
      disabledArtificial: disabledArtificial,
      debouncePlayAudio: debounce((index, item) => this.onAutoSpeech(index, item), 400, {
        leading: true,
        trailing: false,
      }),
      wordTypeSwitch: false,
      wordColor: ["#008FFF", "#9C27B0", "#F54B8D", "#8BC34A", "#FE7C00"],
    }
  },
  computed: {
    clickedAll() {
      return this.dataList.every((item) => item.clicked)
    },
  },
  watch: {
    progress(newVal, oldVal) {
      // 仅在「进入 100」时处理一次，避免进度回调重复推送 100 导致 autoIndex 连跳
      if (newVal === 100 && oldVal !== 100) {
        // 本次音频播放结束，清理当前播放索引
        this.currentPlayingIndex = -1
        // 只有通过自动领读（aiSpeak）播放的音频才更新 autoIndex
        // 避免 playUniversalFormulaAudio 播放完成后错误更新 autoIndex
        if (this.isAutoSpeechPlaying && this.currentSpeakItem.autoIndex !== undefined) {
          //设置领读步骤
          if (this.currentSpeakItem.autoIndex < 5) {
            this.currentSpeakItem.autoIndex++
          } else {
            this.currentSpeakItem.autoIndex = undefined //废弃发音步骤
            this.currentSpeakItem.autoStudyNewWord = false //把这个单词标记为已学过

            //找到蓝光指引的单词下标（下标 0 合法，不能用 if (next)）
            const next = this.getCurrentClueIndex()
            if (next !== undefined && next !== null) {
              this.autoButtonIndex = next
            }
          }
        }
        // 重置标志
        this.isAutoSpeechPlaying = false
      }
    },
    //       this.exerciseModalTxt = this.isManual ? disabledAi : disabledArtificial;
    hasModeSwitch(val) {
      if (!val) {
        this.exerciseModalTxt = this.isManual ? disabledAi : disabledArtificial
      } else {
        this.exerciseModalTxt = this.isManual ? aiClassing : handleClick
      }
    },
  },
  mounted() {
    this.userinfo = this.store.getUser()
    this.queryVocabulary(1)
    this.store.setAfterTestFlag("AFTER_TEST")
    this.getAudioType()
  },
  methods: {
    playUniversalFormulaAudio,
    getBrandImageUrl,
    changeWordType() {
      this.wordTypeSwitch = !this.wordTypeSwitch
      this.changeFontSize()
    },
    changeFontSize() {
      if (this.wordTypeSwitch) {
        this.$nextTick(() => {
          const els = document.querySelectorAll(".enword-list")
          els.forEach((item) => {
            this.adjustFontSizeToFit(item)
          })
        })
      }
    },
    adjustFontSizeToFit(element, minFontSize = 8) {
      let fontSize = 26 //固定基础字体大小，避免在打乱单词时字体到校错乱
      const line1 = element.parentNode.querySelector(".line1")
      const line2 = element.parentNode.querySelector(".line2")
      const line3 = element.parentNode.querySelector(".line3")
      const line4 = element.parentNode.querySelector(".line4")

      element.style.fontSize = `3.5vh`
      element.style.height = `calc(6vh + 4px)`
      line1.style.top = `calc(6vh / 3 * 0)`
      line2.style.top = `calc(6vh / 3 * 1)`
      line3.style.top = `calc(6vh / 3 * 2)`
      line4.style.top = `calc(6vh / 3 * 3)`
      while (element.scrollWidth > element.offsetWidth && fontSize > minFontSize) {
        fontSize -= 0.5
        element.style.fontSize = `${fontSize}px`
        element.style.height = `calc(${fontSize}px * 1.714 + 4px)`
        line1.style.top = `calc(${fontSize}px * 1.714 / 3 * 0)`
        line2.style.top = `calc(${fontSize}px * 1.714 / 3 * 1)`
        line3.style.top = `calc(${fontSize}px * 1.714 / 3 * 2)`
        line4.style.top = `calc(${fontSize}px * 1.714 / 3 * 3)`
      }
    },
    onDrag() {
      this.slidingItemClicked = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.slidingItemClicked = false
      }, 500)
    },
    async openErrorSubmitDialog(item, event) {
      const modal = await modalController.create({
        component: ErrorSubmitDialog,
        componentProps: { wordObj: item },
        backdropDismiss: false,
        cssClass: "common_center_modal_container_transparent1",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("cancel" === data) {
        const parent = event.target.parentNode.parentNode
        if (parent.className.includes("itemStyle")) {
          parent.close()
        } else {
          parent.parentNode.close()
        }
        await modal.dismiss()
      }
    },
    async changeExerciseModal() {
      if (!this.hasModeSwitch) {
        return
      }
      const modal = await modalController.create({
        component: switchModeDialog,
        componentProps: { hasModeSwitch: this.hasModeSwitch, isManual: this.isManual },
        cssClass: "switch_modal_transparent",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" !== data) {
        return
      }
      this.wordTypeSwitch = false
      this.isManual = !this.isManual
      this.onResetStatus()
      if (this.isManual) {
        this.exerciseModalTxt = aiClassing
      } else {
        this.exerciseModalTxt = handleClick
      }
      this.addToSequence()
    },

    routerBack() {
      modalController.dismiss()
    },
    //显示点击动画
    autoShowClickGif(idx) {
      const img = document.getElementById("img_click_" + idx)
      img.style.display = "block"
      setTimeout(() => {
        img.style.display = "none"
      }, 1000)
    },

    // item.autoIndex         领读步骤，1,2,3,4,5
    // this.autoButtonIndex   当前领读按钮下标
    // item.autoStudyNewWord  是否是新单词

    //控制领读是否显示
    autoShowClickButton(index, item) {
      return (
        item.autoIndex && item.autoStudyNewWord && this.autoButtonIndex === index && !this.isManual
      )
    },

    //获取蓝光指引的单词下标
    getCurrentClueIndex() {
      return this.wordSequence[this.currentWordIndex]
    },

    //重置自动领读状态
    autoResetStatus() {
      this.autoButtonIndex = 0
    },

    //调接口，文字转语音
    autoProduceSound(url, param) {
      // http://47.254.121.216:6039/api/speechMsg 英文发音
      // http://47.254.121.216:6039/api/speechMsgForZh  中英文发音

      let voiceUrl = "http://47.254.121.216:6039/"

      myAjax.post(url, param).then((res) => {
        voiceUrl = voiceUrl + res.data.msg
        this.audio(voiceUrl)
      })
    },

    //设置当前单词的点击状态
    controlItemStatus(itemIndex) {
      // 条目单词和注释的是否显示控制
      for (let i = 0; i < this.dataList.length; i++) {
        if (itemIndex === i) {
          if (!this.isManual) {
            // AI 带读：显隐与 autoIndex 绑定，避免连点/回访把计数加到 4 导致第 3、4 步单词消失
            // 1/2 显示单词；3/4 显示单词+释义；5 隐藏单词（听音识词）
            const step = this.dataList[i].autoIndex
            if (step === 5) {
              this.dataList[i].showParaphrase = 4
            } else if (step === 3 || step === 4) {
              this.dataList[i].showParaphrase = 3
            } else if (step === 1 || step === 2) {
              this.dataList[i].showParaphrase = step
            } else {
              // 步骤已结束，恢复显示单词
              this.dataList[i].showParaphrase = 1
            }
          } else {
            // 人工带读：按点击次数循环（0→1→2→3→1...）
            const statusNum = 3
            if (this.dataList[i].showParaphrase < statusNum) {
              this.dataList[i].showParaphrase++
            } else {
              this.dataList[i].showParaphrase = 1
              if (this.wordTypeSwitch) {
                this.changeFontSize()
              }
            }
          }
        } else {
          //重置其它单词点击状态
          this.dataList[i].showParaphrase = 0
        }
      }
    },

    //重置所有单词状态
    onResetStatus() {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].showParaphrase = 0
        this.dataList[i].clicked = false
        this.dataList[i].checked = false
        this.dataList[i].autoIndex = 1
        this.dataList[i].autoStudyNewWord = true
      }

      this.isDownward = true //自动发音方向
      this.speakIndex = 0 //当前发音数组下标
      this.currentWordIndex = 1 //当前所学单词在整个练习流程中的数组下标
      this.autoButtonIndex = 0 //显示自动点击按钮,决定当前显示哪一个按钮
    },

    //显示单词释义，自动带读专用
    onShowParaphraseAuto(itemIndex, item, playSW) {
      // 高亮显示当前点击的条目
      this.changeStyle(itemIndex)

      //根据播放参数，判断本次点击是否需要发音
      if (playSW) {
        this.playSoundTemp(item)
      }

      //用于点击小喇叭图标时进行控制
      this.speakIndex = itemIndex

      //设置当前单词的点击状态为：已点击
      this.dataList[itemIndex].clicked = true

      // 点击到蓝光指引的单词时，控制领读步骤
      if (
        itemIndex === this.wordSequence[this.currentWordIndex] &&
        this.currentWordIndex < this.wordSequence.length
      ) {
        //移动数组下标到下一个单词
        this.currentWordIndex++

        //获取当前领读流程下的单词在单词列表的下标
        const next = this.getCurrentClueIndex()
        // 下标 0 合法，不能写 if (next && ...)
        if (
          next !== undefined &&
          next !== null &&
          this.dataList[next]?.autoStudyNewWord
        ) {
          this.autoButtonIndex = next
        }

        //---------------------------------------

        // 如果流程到24步，标题改为本组复习
        if (this.currentWordIndex === 24) {
          this.pageTitle = "本组复习"
        }

        // 如果流程到33步，标题改为听音识词
        else if (this.currentWordIndex === 33) {
          this.pageTitle = "听音识词"
        }
      }

      //控制当前单词和注释的显隐状态
      this.controlItemStatus(itemIndex)
    },

    //自动领读
    async onAutoSpeech(idx, item) {
      this.currentSpeakItem = item
      // 确保 autoAudio 指向单例实例，以便检测到所有音频播放状态（包括 playUniversalFormulaAudio）
      if (!this.autoAudio) {
        this.autoAudio = getOssPlayInstance()
      }
      if (this.autoAudio?.loading) {
        return
      }

      // 记录当前播放的索引，仅该索引展示过渡样式
      this.currentPlayingIndex = idx
      //this.autoShowClickGif(idx);
      if (!item.autoIndex) {
        return
      }
      this.hasModeSwitch = false
      // 重要：用于人工和自动相互影响
      // 1/2/3/5：更新流程指引 + 显隐；4：只同步显隐（保持单词+释义），不推进蓝光步骤
      if ([1, 2, 3, 5].includes(item.autoIndex)) {
        this.onShowParaphraseAuto(idx, item, false)
      } else if (item.autoIndex === 4) {
        this.changeStyle(idx)
        this.controlItemStatus(idx)
      }
      this.aiSpeak(item)
    },
    aiSpeak(item) {
      const param = {
        msgId: item.vocabularyId + "_" + item.autoIndex,
      }

      let mySpeed = 60

      switch (item.autoIndex) {
        case 2:
          param.msg = item.word + "#" + item.word + "#" + item.word
          mySpeed = 70
          break
        case 3:
          param.msg = item.word + "#" + item.paraphrase
          mySpeed = 70
          break
        case 4:
          param.msg = item.word + "#" + item.word + "#" + item.paraphrase
          mySpeed = 70
          break
        default:
          param.msg = item.word
        //url = api1;
      }

      //调用发音接口
      const trueSpeed = mySpeed * speedRate.value > 100 ? 100 : mySpeed * speedRate.value
      const audioTypeRes = localStorage.getItem("audioType") ?? "DNO01"
      this.autoAudio = getOssPlayInstance().init({
        msg: param.msg,
        rate: speedRate.value,
        speed: trueSpeed,
        audioPath: audioTypeRes,
      })
      // 标记这是自动领读音频
      this.isAutoSpeechPlaying = true
      this.autoAudio.setProgressCallback((val) => (this.progress = val))
      this.autoAudio.play()
    },
    //________________________________________________________________________

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.queryVocabulary(this.currentStep, RefreshAnimationEvent)
    },

    //剪纸盒
    async openCutBox() {
      // 在进入剪纸盒前，彻底停止音频并移除进度回调，避免异步回调回改状态
      if (this.autoAudio) {
        try {
          this.autoAudio.setProgressCallback(null)
        } catch (e) {
          void e
        }
        this.autoAudio.reset()
        this.autoAudio = null
      }
      this.progress = 0
      this.currentPlayingIndex = -1

      //重置自动领读状态
      this.autoResetStatus()
      const modal = await modalController.create({
        component: CutBox,
        componentProps: { studentId: this.studentId, step: this.currentStep },
        cssClass: "modal_controller_class",
        backdropDismiss: false, // 禁止点击背景关闭
        keyboardClose: false, // 禁止ESC按键关闭
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()

      if (data) {
        if (data.status === "TO_SIGN") {
          this.currentStep++
          this.queryVocabulary(this.currentStep)
        } else {
          await modalController.dismiss({ ...data })
        }
      }
      this.hasModeSwitch = true
    },

    //打乱
    async doRandom() {
      const modal = await modalController.create({
        id: "PageDialog",
        component: PageDialog,
        backdropDismiss: false,
        componentProps: {
          message: "打乱后将重新开始练习，确定要打乱吗?",
          type: "hasCancel",
        },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" === data) {
        this.dataList.sort(function () {
          return Math.random() > 0.5 ? -1 : 1
        })
        this.addToSequence()
        this.onResetStatus()
        this.changeFontSize()
      }
    },

    onSpeak() {
      const arr = document.querySelectorAll(".signItem")
      for (let i = 0; i < arr.length; i++) {
        if (this.speakIndex === i) {
          arr[i].click()
          this.dataList[i].clicked = true
        }
      }

      if (this.isDownward) {
        if (this.speakIndex < this.dataList.length - 1) {
          this.speakIndex++
        } else {
          this.speakIndex--
          this.isDownward = false
        }
      } else {
        if (this.speakIndex > 0) {
          this.speakIndex--
        } else {
          this.speakIndex++
          this.isDownward = true
        }
      }
    },

    changeStyle(index) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (index === i) {
          this.dataList[i]["checked"] = true
          this.currentItem = this.dataList[index]
        } else {
          this.dataList[i]["checked"] = false
        }
      }
    },

    onShowParaphrase(itemIndex, item, playSW) {
      //如果是自动且一次没有点击过的单词，则禁止点击
      if (!this.isManual && !item.clicked) {
        return
      }
      if (!this.isManual && this.currentItem.autoIndex !== undefined) {
        return
      }

      this.hasModeSwitch = false
      this.changeStyle(itemIndex)

      if (playSW) {
        //this.playSound(item.word);
        if (!this.isManual) {
          item["playbackRate"] = speedRate.value
        } else {
          item["playbackRate"] = 1
        }
        if (!this.slidingItemClicked) {
          this.playSoundTemp(item)
        }
      }

      this.speakIndex = itemIndex
      this.dataList[itemIndex].clicked = true
      if (itemIndex === this.wordSequence[this.currentWordIndex]) {
        if (this.currentWordIndex < this.wordSequence.length) {
          this.currentWordIndex++

          // 自动领读
          //---------------------------------------
          const next = this.getCurrentClueIndex()
          // 下标 0 合法，不能写 if (next && ...)
          if (
            next !== undefined &&
            next !== null &&
            this.dataList[next]?.autoStudyNewWord
          ) {
            this.autoButtonIndex = next
          }
          //---------------------------------------

          if (this.currentWordIndex === 24) {
            this.pageTitle = "本组复习"
          } else if (this.currentWordIndex === 33) {
            this.pageTitle = "听音识词"
          }
        }
      }

      //控制当前单词和注释的显隐状态
      this.controlItemStatus(itemIndex)
    },

    //标记为难词
    markDifficult(vocabularyId, event) {
      const that = this
      this.ajax
        .post("/vocabulary/markDifficultInForget", {
          studentId: this.studentId,
          vocabularyId: vocabularyId,
          difficult: true,
        })
        .then(() => {
          this.alert("操作成功", function () {
            that.closeSliding(event)
          })
        })
    },

    // 打开有道翻译
    async onParaphrase(word, event) {
      this.closeSliding(event)
      const modal = await modalController.create({
        component: Paraphrase,
        componentProps: { word },
        cssClass: "modal_controller_class",
      })
      await modal.present()
    },

    async routerToAiVocabulary(word) {
      const modal = await modalController.create({
        component: AIGenerate,
        componentProps: { word: word },
      })
      await modal.present()
    },

    queryVocabulary(step, ev) {
      this.ajax
        .post("/vocabulary/queryCurrentWordsNew", {
          studentId: this.studentId,
          pageNum: step,
        })
        .then((res) => {
          const page = res.data.page
          const list = page.list
          this.isDownward = true //自动发音方向
          this.speakIndex = 0 //当前发音数组下标
          this.pageTitle = "单词识记"
          const wordArr = []
          if (list) {
            this.totalPage = page.pages
            for (let i = 0; i < list.length; i++) {
              list[i].status = 1
              list[i].clicked = false
              list[i].showParaphrase = 0
              list[i].autoIndex = 1 //自动发音步骤，1,2,3,4,5
              list[i].autoStudyNewWord = true //是否学新单词

              if (list[i].wordDivision) {
                //是否有单词
                if (/\s/g.test(list[i].wordDivision)) {
                  // 是否为短语
                  list[i].wordDivisionList = list[i].wordDivision
                    .trim()
                    .split(/\s/)
                    .map((item) => item.replace(/[\[\]\/]/g, ""))
                  list[i].wordDivisionType = "phrase"
                } else {
                  list[i].wordDivisionList = list[i].wordDivision
                    .split(/[·]/)
                    .map((item) => item.replace(/[\[\]\/]/g, ""))
                  list[i].wordDivisionType = "word"
                }
              } else {
                list[i].wordDivisionList = []
                list[i].wordDivisionType = "word"
              }
              if (list[i].wordPhonetic) {
                // 是否有释义
                if (/\s/g.test(list[i].wordPhonetic) || list[i].wordPhonetic.includes("…")) {
                  // 是否为短语
                  list[i].wordPhoneticList = list[i].wordPhonetic
                    .trim()
                    .split(/\s/)
                    .map((item) => item.replace(/[\[\]\/]/g, ""))
                  list[i].wordPhoneticType = "phrase"
                } else {
                  list[i].wordPhoneticList = list[i].wordPhonetic
                    .split(/[·]/)
                    .map((item) => item.replace(/[\[\]\/]/g, ""))
                  list[i].wordPhoneticType = "word"
                }
              } else {
                list[i].wordPhoneticList = []
                list[i].wordPhoneticType = "word"
              }
              wordArr.push(list[i].word)
            }
            this.dataList = list
            this.addToSequence()
          }

          if (ev) {
            ev.target.complete()
          }
          if (this.wordTypeSwitch) {
            this.changeFontSize()
          }
        })
    },
    //自动下一步
    addToSequence2() {
      this.wordSequence.push(0)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第一组
      this.wordSequence.push(1)
    },
    //自动下一步
    addToSequence3() {
      this.wordSequence.push(0)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第一组
      this.wordSequence.push(1)
      this.wordSequence.push(2)

      this.wordSequence.push(1)
      this.wordSequence.push(0)
      this.wordSequence.push(1) // 第二组
      this.wordSequence.push(2)
    },
    addToSequence4() {
      this.wordSequence.push(0)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第一组
      this.wordSequence.push(1)
      this.wordSequence.push(2)

      this.wordSequence.push(1)
      this.wordSequence.push(0)
      this.wordSequence.push(1) // 第二组
      this.wordSequence.push(2)
      this.wordSequence.push(3)

      this.wordSequence.push(2)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第三组
      this.wordSequence.push(1)
      this.wordSequence.push(2)

      this.wordSequence.push(3)
    },

    addToSequence5() {
      this.wordSequence.push(0)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第一组
      this.wordSequence.push(1)
      this.wordSequence.push(2)

      this.wordSequence.push(1)
      this.wordSequence.push(0)
      this.wordSequence.push(1) // 第二组
      this.wordSequence.push(2)
      this.wordSequence.push(3)

      this.wordSequence.push(2)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第三组
      this.wordSequence.push(1)
      this.wordSequence.push(2)

      this.wordSequence.push(3)
      this.wordSequence.push(4)
      this.wordSequence.push(3) // 第四组
      this.wordSequence.push(2)
      this.wordSequence.push(3)

      this.wordSequence.push(4)
      this.wordSequence.push(1)
      this.wordSequence.push(0) // 第五组
      this.wordSequence.push(1)
      this.wordSequence.push(0)

      this.wordSequence.push(1)
      this.wordSequence.push(2)
      this.wordSequence.push(3) // 第六组
      this.wordSequence.push(4)
      this.wordSequence.push(3)

      this.wordSequence.push(2)
      this.wordSequence.push(1) // 第七组
      this.wordSequence.push(0)
    },

    addToSequence() {
      this.currentWordIndex = 1
      this.wordSequence = []
      switch (this.dataList.length) {
        case 2:
          this.addToSequence2()
          break
        case 3:
          this.addToSequence3()
          break
        case 4:
          this.addToSequence4()
          break
        case 5:
          this.addToSequence5()
          break
      }
    },
    async getAudioType() {
      const audioTypeRes = await myAjax.get("/AiSwitch/getPronounceType")
      if (audioTypeRes.data.code === 200) {
        localStorage.setItem("audioType", audioTypeRes.data.data ?? "DN001")
      } else {
        localStorage.setItem("audioType", "DN001")
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.sign {
  width: 100%;
  height: 100%;
  position: relative;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: 92%;
    padding: 0.8rem;
    overflow: auto;
    background-color: #ffffff;

    .word-list {
      .w100 {
        flex: 1;
        width: 100%;
      }

      &_item {
        width: 100%;
        //padding: 4vw;
        background-color: var(--page-bg-color);
        border-radius: 2vw;
        margin-bottom: 5vw;
        border: 1px solid transparent;
        position: relative;

        .ion-item {
          width: 100%;
          padding: 4vw;
          background-color: var(--page-bg-color);
          --border-color: transparent;
          --background: transparent;
          --padding-start: 0;
          --inner-padding-end: 0;
          position: relative;

          &::part(native) {
            width: 100%;
          }

          .word-content {
            flex: 1;
            width: calc(100% - 18vw);
          }

          .auto-button {
            width: 18vw;
            height: 7vw;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            //position: absolute;
            //top: 12%;
            //right: 0;
          }
        }

        .auto-index {
          width: 7vw;
          height: 7vw;
          background: #2bca9c;
          color: #fff;
          border-radius: 50%;
          position: relative;

          &::before {
            content: attr(data-progress);
            position: absolute;
            inset: 0.6vw;
            background: #2bca9c;
            width: 5.8vw;
            height: 5.8vw;
            font-size: 1rem;
            line-height: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }
        }

        .auto-index__disabled {
          background: conic-gradient(
            #2bca9c var(--progress),
            transparent 0.1%,
            #2bca9c33 var(--last)
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-1 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #b1b5b8 20%,
            #b1b5b8 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #b1b5b8 40%,
            #b1b5b8 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-2 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #b1b5b8 40%,
            #b1b5b8 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-3 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-4 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #2bca9c 60%,
            #2bca9c 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-5 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #2bca9c 60%,
            #2bca9c 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #2bca9c 80%,
            #2bca9c 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .audio-button {
          width: 7.5vw;
        }

        .sign-option {
          background: var(--page-bg-color);

          &::part(native) {
            padding: 0;
            width: 4rem;
            height: 100%;
          }

          img {
            height: 5rem;
            width: 100%;
            object-fit: fill;
          }
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 2px;
          height: 100%;
          border-radius: 0.5vw;
          background-color: #0b84fb;
          z-index: 999;
        }

        .four-line-three-grid {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          position: relative;
          flex-direction: column;
          width: 100%; /* 根据需要设置宽度 */
          height: 100%; /* 根据需要设置高度 */
        }

        .four-line-three-grid .line1,
        .four-line-three-grid .line2,
        .four-line-three-grid .line3,
        .four-line-three-grid .line4 {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          height: 1px;
        }

        .four-line-three-grid .line1, /* 上线 */
        .four-line-three-grid .line4 {
          /* 下线 */
          background-color: #ddd0c4;
        }

        .four-line-three-grid .line2, /* 中间第一条虚线 */
        .four-line-three-grid .line3 {
          /* 中间第二条虚线 */
          border-bottom: 1px dashed #ddd0c4;
        }

        .four-line-three-grid .line1 {
          top: 0; /* 调整上线位置 */
        }

        .four-line-three-grid .line2 {
          top: 2vh; /* 调整中间第一条虚线位置 */
        }

        .four-line-three-grid .line3 {
          top: 4vh; /* 调整中间第二条虚线位置 */
        }

        .four-line-three-grid .line4 {
          top: 6vh; /* 调整下线位置 */
        }

        .word-style {
          display: inline-block;
          font-size: var(--font-size);
          word-break: break-all;
          max-width: 100%;
        }

        enword {
          padding-left: 20px;
          letter-spacing: 1px;
          max-width: 100%;
          font-size: 2rem;
          display: flex;
          align-items: baseline;
          word-break: break-word;
        }

        .enword-list {
          padding: 0 1rem 0;
          letter-spacing: 1px;
          max-width: 100%;
          font-size: 3vh;
          height: calc(6vh + 4px);
          z-index: 1;
          white-space: nowrap; /* 确保单词在一行显示 */
          overflow: hidden; /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 超出显示省略号 */
          display: flex;
          align-items: baseline;
          justify-content: flex-start;
        }

        .cnword-content {
          width: 100%;
          padding: 0 1rem;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          overflow: auto;
          -ms-overflow-style: none; /* Internet Explorer 10+ */
          scrollbar-width: none; /* Firefox */
          height: fit-content;
        }

        .cnword-content::-webkit-scrollbar {
          display: none; /* Safari 和 Chrome */
        }

        .cnword-content-phonetic {
          font-size: 1rem;
          color: #676767;
          margin-right: 1rem;
          margin-top: 0.5rem;
        }

        .cnword-list {
          bottom: 0;
          font-size: 1rem;
          z-index: 1;
          color: #555555;
          margin-top: 0.5rem;
        }

        .progress {
          position: absolute;
          bottom: 0;
          height: 2px;
          width: 100%;
        }

        .progress-bar {
          background: #ccc;
          width: 0;
          height: 100%;
        }
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  .item-checked {
    border: 1px solid var(--green-bg-color);
    background-color: var(--font-white);
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 8%;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 60%;
      padding: 1.5vh 3vw 0;

      ion-button::part(native) {
        --padding-top: 4vw;
        --padding-bottom: 4vw;
        --padding-start: 4vw;
        --padding-end: 4vw;
      }

      .button {
        height: 5vw;
      }
    }
  }
}

.button-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-icon {
  width: 3.5rem;
  height: 3.5rem;
  cursor: pointer;
  margin-top: 0.6rem;
}

.mode-switch {
  width: 2rem;
  height: 2rem;
  //margin-left: 1rem;
  cursor: pointer;
}

.mode-switch1 {
  height: 1.6rem;
  //margin-left: 1rem;
  cursor: pointer;
}

.button-disabled {
  filter: grayscale(100%);
  cursor: not-allowed;
}

.display-none {
  display: none !important;
}

.sign_page .word-list_item .ion-item {
  --min-height: auto !important;
}
</style>
